




























import { Prop, Component, Vue, Watch, Emit } from 'vue-property-decorator';
import { ParcelFields, ParcelInput } from '@/types/graphql/schemaTypes';
import omit from 'lodash/omit';
import { Table, TableColumn } from 'element-ui';
import ParcelDetails from '@/components/inquiry/new/ParcelDetails.vue';
import Packaging from '@/constants/packaging';

@Component({
  components: {
    ParcelDetails,
    'el-table': Table,
    'el-table-column': TableColumn
  }
})
export default class CargoList extends Vue {
  @Prop() public parcels!: ParcelFields[];
  @Prop({ default: false }) public readOnly!: boolean;
  public editedParcels: ParcelInput[] = [this.emptyParcel()];

  created() {
    if (this.parcels && this.parcels.filter((p: ParcelFields) => (!p.product)).length) {
      this.editedParcels = this.parcels.map((parcel: ParcelFields) => {
        return {
          id: parcel.id || `NOID-${Math.floor(Math.random() * 1000) + 1}`,
          description: parcel.description,
          length: parcel.length,
          width: parcel.width,
          height: parcel.height,
          volume: parcel.volume,
          netWeight: parcel.netWeight,
          packagingType: parcel.packagingType,
          quantity: parcel.quantity
        };
      });
      this.emitParcelDetails();
    }
  }

  public emptyParcel(): ParcelInput {
    return {
      id: `NOID-${Math.floor(Math.random() * 1000) + 1}`,
      packagingType: 'BX',
      length: null,
      width: null,
      height: null,
      quantity: 1,
      description: null
    };
  }

  public addParcel() {
    this.editedParcels.push(this.emptyParcel());
  }

  public editParcel(parcel: any) {
    const parcelIndex = this.editedParcels.findIndex((val) => {
      return val.id === parcel.id;
    });
    this.editedParcels.splice(parcelIndex, 1, parcel);
  }

  public removeParcel(parcelIndex: number) {
    const parcel = this.editedParcels[parcelIndex];
    return this.$delete(this.editedParcels, parcelIndex);
  }

  public packagingTypeFormatter(row: any, column: any, cellValue: string, index: number): string {
    return Packaging[cellValue] || Packaging.ZZ;
  }

  @Watch('editedParcels', { deep: true, immediate: true })
  emitParcelDetails() {
    const noIdParcels = this.editedParcels.map((obj) => {
      return omit(obj, ['id']);
    });
    this.$emit('editCargo', noIdParcels);
  }
}
